'use strict';

var React = require('react');
require('prop-types');
require('../../node_modules/react-dates/lib/initialize.js');
var moment = require('moment');
var DayPicker$1 = require('../../node_modules/react-dates/lib/components/DayPicker.js');
var KeyboardArrowLeft = require('../../node_modules/@material-ui/icons/KeyboardArrowLeft.js');
var KeyboardArrowRight = require('../../node_modules/@material-ui/icons/KeyboardArrowRight.js');
var DayPickerDay = require('./DayPickerDay.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);

var DayPicker = function DayPicker(_ref) {
  var selectedDay = _ref.selectedDay,
      onDayChange = _ref.onDayChange;
  return React__default["default"].createElement(DayPicker$1, {
    key: moment__default["default"](selectedDay).format("M"),
    initialVisibleMonth: function initialVisibleMonth() {
      return moment__default["default"](selectedDay);
    },
    numberOfMonths: 1,
    onDayClick: function onDayClick(moment) {
      return onDayChange(moment.toDate());
    },
    renderDayContents: function renderDayContents(momentDay) {
      return React__default["default"].createElement(DayPickerDay, {
        day: momentDay.format("D"),
        selected: momentDay.isSame(selectedDay, 'day'),
        current: momentDay.isSame(new Date(), 'day')
      });
    },
    hideKeyboardShortcutsPanel: true,
    navPrev: React__default["default"].createElement(KeyboardArrowLeft, {
      style: {
        backgroundColor: "#fff",
        color: "#484848",
        right: "62px",
        padding: "3px",
        position: "absolute",
        top: "24px",
        width: "40px",
        height: "34px"
      }
    }),
    navNext: React__default["default"].createElement(KeyboardArrowRight, {
      style: {
        backgroundColor: "#fff",
        color: "#484848",
        padding: "3px",
        position: "absolute",
        right: "22px",
        top: "24px",
        width: "40px",
        height: "34px"
      }
    })
  });
};

DayPicker.defaultProps = {
  selectedDay: new Date(),
  onDayChange: function onDayChange() {}
};

module.exports = DayPicker;
